import React from "react";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import Checkbox from "@material-ui/core/Checkbox";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
import { Field, change } from "redux-form";

import moment from "moment";
import "moment/locale/es";
moment.locale("es");

export const renderTextField = ({
  input,
  label,
  meta: { touched, error, warning },
  children,
  ...custom
}) => {
  return (
    <FormControl fullWidth margin="dense">
      <TextField
        multiline={input.name === "description"}
        rows={5}
        label={label}
        error={touched && error}
        //helperText={touched && error && <FormHelperText error>{error}</FormHelperText>}
        {...input}
        {...custom}
      />
      {touched &&
        ((error && <FormHelperText error>{error}</FormHelperText>) ||
          (warning && <FormHelperText error>{error}</FormHelperText>))}
    </FormControl>
  );
};

export const renderHiddenField = ({
  input,
  meta: { touched, error },
  children,
  ...custom
}) => {
  return <input {...input} {...custom} />;
};

export const renderNativeDateField = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  return (
    <FormControl fullWidth margin="dense">
      <TextField
        type="date"
        label={label}
        error={touched && typeof error !== "undefined"}
        format="DD/MM/YYY"
        InputLabelProps={{
          shrink: true
        }}
        {...input}
        {...custom}
      />
    </FormControl>
  );
};

export const renderDateField = ({
  input,
  label,
  meta: { touched, error },
  children,
  ...custom
}) => {
  let handleDateChangeRaw = e => {
    e.preventDefault();
  };

  return (
    <FormControl fullWidth margin="dense">
      <DatePicker
        customInput={
          <TextField
            fullWidth
            label={label}
            onClick={input.onClick}
            error={touched && typeof error !== "undefined"}
          />
        }
        //dateForm="DD/MM/YYYY"
        //withPortal
        peekNextMonth
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        dateFormat="DD/MM/YYYY"
        error={touched && typeof error !== "undefined"}
        {...input}
        //value = {custom.initialDate ? custom.initialDate : null}
        selected={input.value ? moment(input.value) : custom.initialDate}
        onChangeRaw={handleDateChangeRaw}
        {...custom}
      />
    </FormControl>
  );
};

export const renderSelectField = ({
  input,
  label,
  placeholder,
  meta: { touched, error },
  children,
  ...custom
}) => (
  <FormControl fullWidth margin="dense">
    {label && <InputLabel>{label}</InputLabel>}
    <Select
      displayEmpty
      native={custom.native}
      error={touched && error}
      {...input}
      //onChange={(event, index, value) => input.onChange(value)}
      disabled={custom.disabled}
    >
      {custom.native && <option selected>{placeholder}</option>}

      {custom.native &&
        typeof custom.data.results !== "undefined" &&
        custom.data.results.map(option => (
          <option value={option.id}>{option.name}</option>
        ))}

      {custom.native &&
        typeof custom.data.results === "undefined" &&
        custom.data.length > 0 &&
        custom.data.map(option => (
          <option value={option.id}>{option.label}</option>
        ))}

      {!custom.native && placeholder && (
        <MenuItem value="" disabled>
          {placeholder}
        </MenuItem>
      )}

      {!custom.native &&
        typeof custom.data.results === "undefined" &&
        custom.data.length > 0 &&
        custom.data.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {option.label}
          </MenuItem>
        ))}

      {!custom.native &&
        typeof custom.data.results !== "undefined" &&
        custom.data.results.map(option => (
          <MenuItem key={option.id} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
    </Select>
  </FormControl>
);

export const renderCheckbox = ({ input, label }) => (
  <FormControlLabel
    label={label}
    control={
      <Checkbox checked={input.value ? true : false} onCheck={input.onChange} />
    }
  />
);

export const renderRadioGroup = ({
  input,
  meta: { touched, error },
  ...rest
}) => {
  const output = (
    <RadioGroup
      {...input}
      {...rest}
      valueSelected={input.value}
      onChange={(event, value) => input.onChange(value)}
    />
  );

  const errorLabel = (
    <FormHelperText error={touched && error}>{error}</FormHelperText>
  );

  return [touched && error ? errorLabel : null, output];
};

export class CheckboxGroup extends React.PureComponent {
  state = {};

  checkboxGroup() {
    let {
      options,
      input,
      meta: { touched, error },
      enableAnswer,
      enabledAnswerlabel,
      enabledAnswerAcceptedValues,
      enableRadioGroupAnswer,
      enabledRadioGroupLabels,
      allowedIndexes
    } = this.props;

    if (typeof enabledAnswerAcceptedValues === "undefined") {
      enabledAnswerAcceptedValues = [];
    }

    const output = options.map((option, index) => {
      let test = [...input.value];

      return (
        <React.Fragment>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  name={`${input.name}[${index}]`}
                  value={option.id}
                  checked={input.value.indexOf(option.id) !== -1}
                  onChange={event => {
                    const newValue = [...input.value];
                    if (event.target.checked) {
                      newValue.push(option.id);
                      test.push(option.id);

                      if (
                        input.name === "test_application_zone" &&
                        option.id === 1
                      ) {
                        options.forEach(option => {
                          option.id !== 1 &&
                            !newValue.includes(option.id) &&
                            newValue.push(option.id);
                        });
                      }
                    } else {
                      newValue.splice(newValue.indexOf(option.id), 1);
                      test.splice(test.indexOf(option.id), 1);

                      if (input.name === "test_application_zone") {
                        if (option.id === 1) {
                          newValue.splice(0, newValue.length);
                        } else {
                          newValue.includes(1) &&
                            newValue.splice(newValue.indexOf(1), 1);
                        }
                      }
                    }

                    return input.onChange(newValue);
                  }}
                  style={{
                    width: 48,
                    height: 36
                  }}
                />
              }
              label={option.value}
            />
          </FormGroup>

          {enableAnswer &&
            Array.isArray(allowedIndexes) &&
            allowedIndexes.length > 0 &&
            allowedIndexes.includes(option.id) &&
            enabledAnswerAcceptedValues.length == 0 &&
            test.indexOf(option.id) > -1 && (
              <FormGroup fullWidth margin="dense" row>
                <Field
                  component={renderTextField}
                  fullWidth
                  name={`${input.name}_answer[${option.id}]`}
                  label={enabledAnswerlabel ? enabledAnswerlabel : "¿Dónde?"}
                  // value={answers[parseInt(option.id, 10)]}
                  error={true}
                  onChange={event => {
                    console.log("event", event.target.value);
                    input.onChange();
                  }}
                  required
                />
              </FormGroup>
            )}

          {enableAnswer &&
            enabledAnswerAcceptedValues.length == 0 && !Array.isArray(allowedIndexes) &&
            test.indexOf(option.id) > -1 && (
              <Field
                name={`${input.name}_answer[${option.id}]`}
                component={renderTextField}
                label={enabledAnswerlabel ? enabledAnswerlabel : "¿Dónde?"}
              />
            )

          // <FormControl fullWidth margin='dense' row>
          //   <TextField
          //     fullWidth
          //     name={`${input.name}_answer[${option.id}]`}
          //     label={enabledAnswerlabel ? enabledAnswerlabel : "1¿Dónde?"}
          //     error={true}
          //     required
          //   />
          // </FormControl>
          }

          {enableAnswer &&
            enabledAnswerAcceptedValues.length > 0 &&
            test.some(r => enabledAnswerAcceptedValues.includes(r)) === true &&
            enabledAnswerAcceptedValues.includes(option.id) && (
              <FormGroup fullWidth margin="dense" row>
                <TextField
                  fullWidth
                  name={`${input.name}_answer[${option.id}]`}
                  label={enabledAnswerlabel ? enabledAnswerlabel : "2¿Dónde?2"}
                  error={true}
                  required
                />
              </FormGroup>
            )}

          {enableRadioGroupAnswer && test.indexOf(option.id) > -1 && (
            <FormGroup row>
              <Field
                name={`${input.name}_answer[${option.id}]`}
                component={renderRadioGroup}
                style={{ display: "block" }}
              >
                {enabledRadioGroupLabels &&
                  enabledRadioGroupLabels.map(item => (
                    <FormControlLabel
                      key={item.id}
                      control={<Radio />}
                      value={item.value}
                      label={item.label}
                      required
                      error={true}
                    />
                  ))}
              </Field>
            </FormGroup>
          )}
        </React.Fragment>
      );
    });

    const errorLabel = (
      <FormHelperText error={touched && error}>{error}</FormHelperText>
    );

    //return [touched ? errorLabel : '', output]
    return [touched && error ? errorLabel : null, output];
  }

  render() {
    return this.checkboxGroup();
  }
}



// WEBPACK FOOTER //
// ./src/helpers/form/renders.js